import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { useUser } from '@/contexts/userContext';
import { getData } from '@/utils/getData';
import { useCheckout } from '@/contexts/checkoutContext';

// This really returns the entire cart, not just the gift cards,
// but let's play along and call it loading gift cards! 😜
export const useLoadGiftCards = (hasStoredCards: boolean) => {
  const { giftCardsLoaded, setCheckoutData, setGiftCardsLoaded } =
    useCheckout();
  const { isAuthenticated } = useUser();

  const { data, isSuccess } = useQuery({
    enabled: isAuthenticated && !giftCardsLoaded,
    queryFn: getData(Endpoint.LoadGiftCards),
    queryKey: [QueryKey.GiftCards],
  });

  // The following two effects are necessary in order to avoid the
  // "Cannot update a component while rendering a different component" error
  useEffect(() => {
    if (isSuccess && !giftCardsLoaded) {
      setGiftCardsLoaded(true);
    }
  }, [giftCardsLoaded, isSuccess, setGiftCardsLoaded]);

  useEffect(() => {
    if (data?.isSuccess && !hasStoredCards) {
      setCheckoutData(data.data);
    }
  }, [data, hasStoredCards, setCheckoutData]);
};
